module.exports = __webpack_public_path__ + "img/selected1-min.f1a1ad9f.png";